
define('text!TescoMobile_Checkout/template/summary/insurance.html',[],function () { return '<!-- ko if: isDisplayed() --><div class="summary-insurance" data-bind="html: $t(\'%1 a month, which will be taken as a separate payment\').replace(\'%1\', \'<b>\' + getValue() + \'</b>\')"></div><!-- /ko -->';});

